import '@patsnap-biz/design-tokens/scss/_variables-IP.css'
import '@patsnap-ui/icon/assets/solid/EyeOff.svg'
import '@patsnap-ui/icon/assets/solid/FolderMany.svg'
import '@patsnap-ui/icon/assets/solid/move.svg'
import '@patsnap-ui/icon/assets/solid/see.svg'
import { removeRegisterTracking } from '@patsnap/synapse_common_business'
import initWasmEncryptionModule from '@patsnap/synapse_encryption'
import { wujieCommonPlugins } from '@pharmsnap/shared/src/utils/wujie'
import VueCompositionAPI from '@vue/composition-api'
import VueLazyComponent from '@xunlei/vue-lazy-component'
import { useAuthStore } from 'pharmsnapMF_shared/composition'
import { createI18n, I18nLang } from 'pharmsnapMF_shared/i18n'
import { useVxeTable } from 'pharmsnapMF_shared/plugins'
import { initSecurity, removeHistoryQueries, shouldRegisterCopyFunc } from 'pharmsnapMF_shared/utils'
import PortalVue from 'portal-vue'
import Vue from 'vue'
import InfiniteLoading from 'vue-infinite-loading'
import { preloadApp } from 'wujie'
import WujieVue from 'wujie-vue2'
import App from './App'
import { IS_CN_REGION, VUE_APP_MICRO_BASE_URL } from './config'
import { initDevtoolsDetector } from './features/devtools-detector'
import { FreemiumCompleteUserinfo } from './features/freemium-complete-userinfo'
import { SessionChecker } from './features/session-checker'
import { registerEvent } from './module/event/event'
import { registerRegisterTracking } from './module/register-tracking/register-tracking'
import { getSessionIdFromToken, setSynapseLoginCookie } from './module/synapse-cookie/synapse-cookie'
import router from './router'
import { initPassport, initTools, setAppContext } from './service/service'
import './style/style.scss'
import { initSentry } from './utils/auth'
import { getLocaleLang, setLocaleLang } from './utils/business/locale'
import { getLangValue } from './utils/business/uniform-setting'
Vue.use(WujieVue)
Vue.use(PortalVue)
Vue.use(VueCompositionAPI)
Vue.use(InfiniteLoading)
Vue.use(VueLazyComponent)
useVxeTable(Vue)
registerEvent()
registerRegisterTracking()
Vue.config.productionTip = false
;(async () => {
  const [passport] = await Promise.all([initPassport(), initWasmEncryptionModule()])
  const token = passport.getToken('token')
  setAppContext()
  removeHistoryQueries(['login_success'])
  const {
    actions,
    state,
    getters: { isBasicUser, isEnterpriseUser, isFreeUser },
  } = useAuthStore()
  let lang = getLocaleLang()
  if (token) {
    const sessionChecker = new SessionChecker()
    const sessionId = getSessionIdFromToken(token)
    const isNewSession = sessionChecker.checkIsNewSession(sessionId)
    setSynapseLoginCookie(sessionId)
    removeRegisterTracking()
    const [userLang] = await Promise.all([getLangValue(true), actions.syncUserInfo(isNewSession)])
    if (['cn', 'en'].includes(userLang)) {
      lang = userLang as I18nLang
      setLocaleLang(lang)
    }
    //必须在同步用户信息之后调用
    initSecurity(isBasicUser.value || isEnterpriseUser.value)
    // 免费用户且未完善个人信息,统计用户行为,达到一定次数后提示完善个人信息
    if (isFreeUser.value && !state.userInfo.value?.profile_complete) {
      FreemiumCompleteUserinfo.getSingleton({
        userId: state.userInfo.value?.user_id || '',
        router,
      })
    }
  }

  const i18n = await createI18n(lang)
  initTools(state.userInfo.value || undefined)
  new Vue({
    i18n,
    router,
    render: (h) => h(App),
  }).$mount('#app')
  setTimeout(() => {
    initWaterMark(state.userInfo.value?.user_id || '')
    initDevtoolsDetector(() => {
      // 需要在设置完控制台监控后再初始化sentry,否则会导致控制台监控无法正常工作
      // 原因猜测: DevtoolsDetector和sentry都劫持了console.log,如果先初始化sentry,则DevtoolsDetector的判断逻辑会错误
      initSentry(state.userInfo.value)
    })
    shouldRegisterCopyFunc()
    preloadMicroFrontendApp()
  }, 0)
})()
async function initWaterMark(userId: string) {
  if (!userId) {
    return
  }
  const { default: WaterMark } = await import('l-watermark')
  const container: any = document.querySelector('#APP') || document.body
  WaterMark.page({
    target: container,
    text: userId,
    color: 'rgba(0, 0, 0, 0.008)',
    fontSize: 20,
  })
}

function preloadMicroFrontendApp() {
  const entityCardApps = ['drug', 'target', 'disease', 'organization', 'news', 'paper', 'clinical_result', 'clinical_trials', 'patent'].map(
    (item) => {
      return {
        appName: `micro-entity-card-${item}`,
        appUrl: `${VUE_APP_MICRO_BASE_URL}/micro-entity-card/#/${item}`,
      }
    }
  )
  const lsCommonApps = ['upgrade-success', 'upgrade-recently', IS_CN_REGION ? 'complete-user-info-china' : 'complete-user-info-aboard'].map(
    (item) => {
      return {
        appName: `micro-ls-common-${item}`,
        appUrl: `${VUE_APP_MICRO_BASE_URL}/micro-ls-common#/${item}`,
      }
    }
  )
  const allApps = [...entityCardApps, ...lsCommonApps]
  allApps.forEach((item) => {
    preloadApp({
      name: item.appName,
      url: item.appUrl,
      exec: true,
      plugins: wujieCommonPlugins,
    })
  })
}
